<template>
    <section class="about-certification content-section">
        <b-container>
            <b-row class="justify-content-center">
                <b-col cols="12">
                    <h2 class="content-section-title">CERTIFICATION</h2>
                    <div class="owl-carousel owl-theme">
                        <div class="item" v-for="d in 19" :key="d">
                            <b-img :src="require(`@/assets/images/certification/certif_0${d}.jpg`)" fluid></b-img>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    mounted() {
        $('.owl-carousel').owlCarousel({
            loop:true,
            margin:10,
            nav:true,
            autoplay: true,
            autoplaySpeed: 1000,
            autoplayTimeout: 2000,
            navText: [
                'prev',
                'next'
            ],
            responsive:{
                0:{ items:1 },
                600:{ items:3 },
                1000:{ items:5 }
            }
        });
    },
}
</script>